<template>
  <b-breadcrumb class="breadCrumb breadCrumb-folder" v-if="showBreadcrumb(metadata.bread_crumbs)">
    <b-breadcrumb-item v-for="(breadcumb,index) in metadata.bread_crumbs"  @click="listFile(breadcumb.id)" v-bind:key="index" :class="isActive(breadcumb.id)">
      {{truncate(breadcumb.name? breadcumb.name: 'ファイル一覧',10,'...')}}&nbsp;
    </b-breadcrumb-item>
    <b-breadcrumb-item class="breadCrumb breadCrumb-folder breadCrumb-lastItem">
      {{truncate(metadata.current_folder_name,10,'...')}}
    </b-breadcrumb-item>
  </b-breadcrumb>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'Breadcrumb',
  data () {
    return {
    }
  },
  methods: {
    showBreadcrumb (value) {
      if (value) {
        return value.length > 0
      } else {
        return false
      }
    },
    listFile (id) {
      if (this.$route.params.tab) {
        this.$router.push({
          path: `/employee/items/${id}`,
          query: {tab: this.$route.params.tab}
        })
      } else {
        this.$router.push(`/employee/items/${id}`)
      }
    },
    isActive (value) {
      return value === this.$route.params.id ? 'active' : ''
    }
  },
  props: {
    active: ''
  },
  computed: {
    ...mapState({
      metadata: state => state.employeeFolder.metadata
    })
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/auth/breadcrumb.scss";
</style>



// WEBPACK FOOTER //
// src/components/Employee/FolderManagerment/Breadcrumb.vue